import get from 'lodash/get';
import styled, { css } from 'styled-components';
import { Typography } from '~/ui/components';
import { blink } from '~/ui/theme/animations';

export const KanbanColumn = styled.div<{ bgColor?: string; borderColor?: string }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ bgColor, theme }) => get(theme.colors, bgColor) || bgColor};
  border-color: ${({ borderColor, theme }) => get(theme.colors, borderColor) || borderColor};
  border-radius: 16px;
  height: auto;
  max-height: 100%;
  border-width: 1px;
  border-style: solid;
  min-width: 340px;
  width: 100%;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.4;
      pointer-events: none;
    `}
`;

export const ColumnHeaderTitle = styled(Typography).attrs({
  type: 'bodyXSmall',
  weight: '700',
  center: true,
  element: 'div',
})`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const KanbanColumnHeader = styled.div`
  padding: 8px 12px 4px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .dots-icon {
    cursor: pointer;
    color: ${({ color, theme }) => get(theme.colors, color) || color};
  }

  .typography {
    color: ${({ color, theme }) => get(theme.colors, color) || color};
  }
`;

export const KanbanColumnContent = styled.div`
  padding: 4px 8px 8px 8px;
  overflow-y: auto;
  flex: 1;
  max-height: calc(100vh - 240px);
  display: flex;
  flex-direction: column;
  gap: 8px;

  .load-more-button {
    .typography {
      font-size: 12px;
    }
  }

  .no-items {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    opacity: 0.5;
  }

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 40px);
  gap: 8px;

  span {
    animation: 2s ease-in-out ${blink} infinite;
  }
`;
